/* ============================================================
 * Probador virtual Indigosite — frontend del snippet Shopify
 * ------------------------------------------------------------
 * Vanilla JS, sin dependencias.
 * Configuración: window.INDIGOSITE_APP_URL (URL base del backend,
 * sin slash final). La clave de API nunca va aquí: todo pasa
 * por el backend, que guarda el token en localStorage.
 * Endpoints usados (ver docs/API.md):
 *   POST /api/auth/register  {email} -> {token}
 *   POST /api/auth/login     {email} -> {token, plan}
 *   GET  /api/me             -> {email, plan, tryons_remaining}
 *   POST /api/upload         multipart campo "file" -> {url}
 *   POST /api/tryon          {model_image, garment_image, category}
 * ============================================================ */
(function () {
  'use strict';

  // Evita doble inicialización si el snippet se renderiza más de una vez.
  if (window.__indTryonInit) return;
  window.__indTryonInit = true;

  var API_URL = String(window.INDIGOSITE_APP_URL || '').replace(/\/+$/, '');
  var TOKEN_KEY = 'indigosite_tryon_token';
  var MAX_BYTES = 8 * 1024 * 1024; // 8MB, igual que el backend
  var OK_TYPES = ['image/jpeg', 'image/png', 'image/webp'];

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }

  function getToken() {
    try { return localStorage.getItem(TOKEN_KEY); } catch (e) { return null; }
  }
  function setToken(t) {
    try {
      if (t) localStorage.setItem(TOKEN_KEY, t);
      else localStorage.removeItem(TOKEN_KEY);
    } catch (e) { /* almacenamiento no disponible: se sigue sin persistir */ }
  }

  // Llamada a la API. Resuelve con el JSON; rechaza con {status, message}.
  function api(path, opts) {
    opts = opts || {};
    var headers = { 'Accept': 'application/json' };
    var token = getToken();
    if (token) headers['Authorization'] = 'Bearer ' + token;
    var body = opts.body;
    if (body && !(body instanceof FormData)) {
      headers['Content-Type'] = 'application/json';
      body = JSON.stringify(body);
    }
    return fetch(API_URL + path, {
      method: opts.method || 'GET',
      headers: headers,
      body: body
    }).then(function (resp) {
      return resp.text().then(function (text) {
        var data = null;
        try { data = text ? JSON.parse(text) : null; } catch (e) { /* respuesta no JSON */ }
        if (!resp.ok) {
          var msg = (data && (data.detail || data.message)) || ('Error ' + resp.status);
          throw { status: resp.status, message: msg };
        }
        return data;
      });
    }).catch(function (err) {
      if (err && typeof err.status === 'number') throw err;
      throw { status: 0, message: 'Sin conexión. Revisa tu internet e inténtalo de nuevo.' };
    });
  }

  function init() {
    var root = $('.ind-tryon');
    if (!root) return; // el snippet no está en esta página

    // El overlay es hermano del botón dentro del mismo snippet.
    var overlay = root.parentNode
      ? root.parentNode.querySelector('[data-ind-tryon-overlay]')
      : document.querySelector('[data-ind-tryon-overlay]');
    if (!overlay) return;

    var garmentImage = root.getAttribute('data-garment-image') || '';
    var state = { modelImageUrl: null, lastFile: null };

    function showStep(name) {
      var steps = overlay.querySelectorAll('[data-ind-tryon-step]');
      for (var i = 0; i < steps.length; i++) {
        steps[i].hidden = steps[i].getAttribute('data-ind-tryon-step') !== name;
      }
    }

    function setRemaining(selectors, n) {
      selectors.forEach(function (sel) {
        var el = overlay.querySelector(sel);
        if (!el) return;
        if (typeof n === 'number') {
          el.hidden = false;
          el.textContent = 'Te quedan ' + n + ' pruebas gratis hoy.';
        } else {
          el.hidden = true;
        }
      });
    }

    function showErrorText(text) {
      var el = overlay.querySelector('[data-ind-tryon-error-text]');
      if (el) el.textContent = text;
      showStep('error');
    }

    function openModal() {
      overlay.hidden = false;
      document.body.style.overflow = 'hidden';
      if (!API_URL) { showStep('config'); return; }
      var token = getToken();
      if (!token) { showStep('email'); return; }
      showStep('loading');
      api('/api/me').then(function (me) {
        setRemaining(['[data-ind-tryon-remaining]'], me && me.tryons_remaining);
        resetPhotoStep();
        showStep('photo');
      }).catch(function (err) {
        if (err.status === 401) {
          setToken(null);
          showStep('email');
        } else if (err.status === 429) {
          showStep('limit');
        } else {
          showErrorText(err.message);
        }
      });
    }

    function closeModal() {
      overlay.hidden = true;
      document.body.style.overflow = '';
    }

    function resetPhotoStep() {
      state.modelImageUrl = null;
      state.lastFile = null;
      var fileInput = overlay.querySelector('[data-ind-tryon-file]');
      if (fileInput) fileInput.value = '';
      var nameEl = overlay.querySelector('[data-ind-tryon-file-name]');
      if (nameEl) nameEl.textContent = 'Sin archivo seleccionado';
      var preview = overlay.querySelector('[data-ind-tryon-preview]');
      if (preview) preview.hidden = true;
      var gen = overlay.querySelector('[data-ind-tryon-generate]');
      if (gen) { gen.disabled = true; gen.textContent = 'Generar mi prueba'; }
      var errEl = overlay.querySelector('[data-ind-tryon-photo-error]');
      if (errEl) errEl.hidden = true;
    }

    function photoError(msg) {
      var el = overlay.querySelector('[data-ind-tryon-photo-error]');
      if (el) { el.textContent = msg; el.hidden = false; }
    }

    // ---- Paso 1: email -> login, o registro si no existe ----
    var emailForm = overlay.querySelector('[data-ind-tryon-email-form]');
    if (emailForm) {
      emailForm.addEventListener('submit', function (ev) {
        ev.preventDefault();
        var input = overlay.querySelector('[data-ind-tryon-email]');
        var errEl = overlay.querySelector('[data-ind-tryon-email-error]');
        var submit = overlay.querySelector('[data-ind-tryon-email-submit]');
        var email = String(input.value || '').trim().toLowerCase();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          errEl.textContent = 'Ingresa un email válido, por favor.';
          errEl.hidden = false;
          return;
        }
        errEl.hidden = true;
        submit.disabled = true;
        submit.textContent = 'Verificando…';

        function done(token) {
          setToken(token);
          submit.disabled = false;
          submit.textContent = 'Continuar';
          api('/api/me').then(function (me) {
            setRemaining(['[data-ind-tryon-remaining]'], me && me.tryons_remaining);
          }).catch(function () { /* no bloquea el flujo */ });
          resetPhotoStep();
          showStep('photo');
        }

        api('/api/auth/login', { method: 'POST', body: { email: email } })
          .then(function (res) { done(res.token); })
          .catch(function (err) {
            if (err.status === 401 || err.status === 404) {
              // No existe: la registramos.
              return api('/api/auth/register', { method: 'POST', body: { email: email } })
                .then(function (res) { done(res.token); });
            }
            throw err;
          })
          .catch(function (err) {
            submit.disabled = false;
            submit.textContent = 'Continuar';
            errEl.textContent = err.message || 'No pudimos continuar. Inténtalo de nuevo.';
            errEl.hidden = false;
          });
      });
    }

    // ---- Paso 2: foto ----
    var fileInput = overlay.querySelector('[data-ind-tryon-file]');
    if (fileInput) {
      fileInput.addEventListener('change', function () {
        var file = fileInput.files && fileInput.files[0];
        var gen = overlay.querySelector('[data-ind-tryon-generate]');
        var errEl = overlay.querySelector('[data-ind-tryon-photo-error]');
        if (errEl) errEl.hidden = true;
        if (!file) { resetPhotoStep(); return; }
        if (OK_TYPES.indexOf(file.type) === -1) {
          photoError('Formato no válido. Usa JPG, PNG o WebP.');
          resetPhotoStep();
          return;
        }
        if (file.size > MAX_BYTES) {
          photoError('La foto pesa más de 8MB. Elige una más liviana.');
          resetPhotoStep();
          return;
        }
        state.lastFile = file;
        var nameEl = overlay.querySelector('[data-ind-tryon-file-name]');
        if (nameEl) nameEl.textContent = file.name;
        var preview = overlay.querySelector('[data-ind-tryon-preview]');
        var previewImg = overlay.querySelector('[data-ind-tryon-preview-img]');
        if (preview && previewImg) {
          // Libera el object URL anterior si existía.
          if (previewImg.src && previewImg.src.indexOf('blob:') === 0) {
            try { URL.revokeObjectURL(previewImg.src); } catch (e) {}
          }
          previewImg.src = URL.createObjectURL(file);
          preview.hidden = false;
        }
        if (gen) gen.disabled = false;
      });
    }

    var generateBtn = overlay.querySelector('[data-ind-tryon-generate]');
    if (generateBtn) {
      generateBtn.addEventListener('click', function () {
        if (!state.lastFile) return;
        generateBtn.disabled = true;
        generateBtn.textContent = 'Subiendo foto…';
        var fd = new FormData();
        fd.append('file', state.lastFile);

        api('/api/upload', { method: 'POST', body: fd })
          .then(function (up) {
            if (!up || !up.url) throw { status: 0, message: 'No se pudo subir tu foto.' };
            // El backend devuelve ruta relativa (/uploads/...); se completa con la base.
            state.modelImageUrl = API_URL + (up.url.charAt(0) === '/' ? '' : '/') + up.url;
            generateBtn.textContent = 'Generando…';
            showStep('loading');
            return api('/api/tryon', {
              method: 'POST',
              body: {
                model_image: state.modelImageUrl,
                garment_image: garmentImage,
                category: 'auto'
              }
            });
          })
          .then(function (res) {
            var img = overlay.querySelector('[data-ind-tryon-result-img]');
            if (img) img.src = res.image_url;
            setRemaining(
              ['[data-ind-tryon-remaining-result]'],
              res && typeof res.tryons_remaining === 'number' ? res.tryons_remaining : null
            );
            showStep('result');
          })
          .catch(function (err) {
            if (err.status === 429) { showStep('limit'); return; }
            if (err.status === 502) { showStep('failed'); return; }
            if (err.status === 401) {
              setToken(null);
              showStep('email');
              var emailErr = overlay.querySelector('[data-ind-tryon-email-error]');
              if (emailErr) {
                emailErr.textContent = 'Tu sesión expiró. Ingresa tu email de nuevo.';
                emailErr.hidden = false;
              }
              return;
            }
            showErrorText(err.message || 'Ocurrió un error inesperado.');
          })
          .then(function () {
            // Restaura el botón para el próximo intento (salvo que ya estemos en resultado).
            var step = overlay.querySelector('[data-ind-tryon-step="result"]');
            if (!step || step.hidden) {
              generateBtn.disabled = !state.lastFile;
              generateBtn.textContent = 'Generar mi prueba';
            }
          });
      });
    }

    // ---- Navegación del modal ----
    var openBtns = document.querySelectorAll('[data-ind-tryon-open]');
    for (var i = 0; i < openBtns.length; i++) {
      openBtns[i].addEventListener('click', openModal);
    }
    var closeBtns = overlay.querySelectorAll('[data-ind-tryon-close]');
    for (var j = 0; j < closeBtns.length; j++) {
      closeBtns[j].addEventListener('click', closeModal);
    }
    overlay.addEventListener('click', function (ev) {
      if (ev.target === overlay) closeModal();
    });
    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' && !overlay.hidden) closeModal();
    });

    var againBtn = overlay.querySelector('[data-ind-tryon-again]');
    if (againBtn) {
      againBtn.addEventListener('click', function () {
        api('/api/me').then(function (me) {
          setRemaining(['[data-ind-tryon-remaining]'], me && me.tryons_remaining);
        }).catch(function () {});
        resetPhotoStep();
        showStep('photo');
      });
    }

    var retryBtn = overlay.querySelector('[data-ind-tryon-retry]');
    if (retryBtn) {
      retryBtn.addEventListener('click', function () {
        // Reintenta la última generación si aún hay foto y prenda.
        if (state.lastFile && garmentImage) {
          resetPhotoStepKeepFile();
          showStep('photo');
          var gen = overlay.querySelector('[data-ind-tryon-generate]');
          if (gen) gen.click();
        } else {
          showStep('photo');
        }
      });
    }

    function resetPhotoStepKeepFile() {
      // Conserva el archivo elegido para el reintento, solo limpia errores.
      var errEl = overlay.querySelector('[data-ind-tryon-photo-error]');
      if (errEl) errEl.hidden = true;
      var gen = overlay.querySelector('[data-ind-tryon-generate]');
      if (gen && state.lastFile) gen.disabled = false;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
